import { ActionTree } from 'vuex'
import * as types from './mutation-types'
import RootState from '@vue-storefront/core/types/RootState'
import LocationsState from '../../types/LocationsState'
import { processURLAddress } from '@vue-storefront/core/helpers'
import fetch from 'isomorphic-fetch'
import config from 'config'
import rootStore from '@vue-storefront/core/store'
import { isServer } from '@vue-storefront/core/helpers'

const actions: ActionTree<LocationsState, RootState> = {
  loadLocations ({commit}) {
    let url = processURLAddress(`${config.locations.base_endpoint}/list/locations`)
    return fetch(url, { method: config.elasticsearch.queryMethod,
      mode: 'cors',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(resp => resp.json())
      .then(response => {
        commit(types.SET_LOCATIONS, response.result)
        response.result.forEach(async (location) => {
          await rootStore.dispatch('url/registerMapping', {
            url: location.code,
            routeData: {
              params: {
                'locationCode': location.code
              },
              name: 'location'
            }
          }, { root: true })
        })
        return response.result
      })
      .catch(error => {
        throw new Error('FetchError in request to ES: ' + error.toString())
      })
  },
  /**
   * Syncs the active city to a partner-scoped route; no-op when unchanged. Skips
   * setCurrentLocation's partner/category list load - the page loads its own partner.
   */
  async ensureLocation ({ state, getters, dispatch }, code) {
    const active = getters.getActiveLocation
    if (!code || (active && active.code === code)) {
      return
    }
    if (!state.locations.length) {
      await dispatch('loadLocations')
    }
    if (state.locations.find(l => l.code === code)) {
      await dispatch('setCurrentLocation', { code, skipListLoad: true })
    }
  },
  async setCurrentLocation ({ state, commit }, { code = null, forceCategoriesLoad = false, skipListLoad = false }) {
    await rootStore.dispatch('partners/resetCurrentPartner')
    let location = code !== null ? state.locations.find(l => l.code === code) : null
    commit(types.SET_CURRENT_LOCATION, location)
    if (location && !isServer) {
      let currentCustomer = rootStore.state.user.current
      if (currentCustomer && currentCustomer.default_location_code && currentCustomer.default_location_code !== code) {
        rootStore.dispatch('user/updateDefaultLocation', code)
          .catch(err => console.log(err))
      }
      let cartToken = !rootStore.getters['cart/getCartToken'] ? '' : rootStore.getters['cart/getCartToken']
      let userToken = !rootStore.getters['user/getUserToken'] ? '' : rootStore.getters['user/getUserToken']
      rootStore.dispatch('cart/loadCount', { token: userToken, cartToken, location_code: location.code })
      rootStore.dispatch('cart/loadItemsCart', { location_code: location.code, cartToken, token: userToken })
      if (skipListLoad) {
        return
      }
      if (location.layout_code !== 'partners_only' && forceCategoriesLoad) {
        return await rootStore.dispatch('partner_categories/loadCategories', { locationCode: location.code })
      } else {
        return await rootStore.dispatch('partners/loadPartners', { locationCode: location.code })
      }
    }
  }
}

export default actions
